import React from "react";

import { bem } from "@react-md/utils";
import AntDAvatar, { AvatarProps as AntDAvatarProps } from "antd/es/avatar";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";

import { UserRef } from "@mapmycustomers/shared/types/User";
import getInitials from "@mapmycustomers/shared/util/ui/getInitials";

import { useConfigProvider } from "../ConfigProvider";

import colorStyles from "./AvatarColor.module.scss";
import { getUserDisplayNameWithInfo } from "./util/getUserDisplayNameWithInfo";

const block = bem("mmc-avatar");

export interface AvatarProps extends Omit<AntDAvatarProps, "className" | "size"> {
  actionOnHover?: boolean;
  className?: string;
  size?: "m" | "s" | "xs";
  tooltip?: boolean;
  user: UserRef;
}

const Avatar = ({
  actionOnHover,
  className,
  size,
  tooltip = true,
  user,
  ...avatarProps
}: AvatarProps) => {
  const configProvider = useConfigProvider();
  const profilePhotoUrl = configProvider.complementFileUrl(user.profilePhoto?.publicURI);

  const nameInitials = getInitials(user);

  let colorClassName;
  if (!profilePhotoUrl) {
    colorClassName = colorStyles[configProvider.getUserColorClassName(user) as string];
  }

  return (
    <Tooltip
      title={
        tooltip
          ? actionOnHover && !user.deletedAt && !user.deactivated
            ? configProvider.formatMessage("ui.avatar.tooltip.open", {
                name: getUserDisplayNameWithInfo(configProvider, user),
              })
            : getUserDisplayNameWithInfo(configProvider, user)
          : undefined
      }
    >
      <AntDAvatar
        className={cn(
          block("avatarIcon", {
            [`size_${size}`]: !!size,
            avatarHover: actionOnHover,
          }),
          colorClassName,
          className
        )}
        src={profilePhotoUrl}
        {...avatarProps}
      >
        {profilePhotoUrl ? " " : nameInitials}
      </AntDAvatar>
    </Tooltip>
  );
};

// Empty object preventing passing dispatch prop to the component
export default Avatar;
